(function () {
    'use strict';
    var controllerId = '4a_pcModuloAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'modulo', 'corsoId', 'opInsert', fn_4a_pcModuloAdd]);

    function fn_4a_pcModuloAdd($scope, $uibModalInstance, modulo, corsoId, opInsert) {
        $scope.Title = '';

        if (modulo) {
            $scope.record = jQuery.extend({}, modulo); //Clona oggetto.
            $scope.Title = 'Modifica Modulo (ID: ' + $scope.record.Id + ')';
        }
        else {
            $scope.Title = 'Nuovo Modulo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.DtInsert = new Date();
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
            $scope.record.M4A_bModuliSpecifici = true;
        }   

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

    }
})();